import React, { SVGProps } from "react";

interface PhoneIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const PhoneIcon: React.FC<PhoneIconProps> = ({
  className,
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M3 1.5H7L9 6.5L6.5 8C7.57096 10.1715 9.32847 11.929 11.5 13L13 10.5L18 12.5V16.5C18 17.0304 17.7893 17.5391 17.4142 17.9142C17.0391 18.2893 16.5304 18.5 16 18.5C12.0993 18.263 8.42015 16.6065 5.65683 13.8432C2.8935 11.0798 1.23705 7.40074 1 3.5C1 2.96957 1.21071 2.46086 1.58579 2.08579C1.96086 1.71071 2.46957 1.5 3 1.5Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
